import Indicator from '../Indicator';

/** EMA indicator */
export default class MomentumIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {number} fillToValue - Value to fill to with background color
	 */
	_getDefaultParams() {
		return {
			id: 'momentum',
			name: 'Momentum',
			description: 'The Momentum chart indicator measures the rate of change or speed of price movement of a financial instrument, signaling whether the price is moving up or down and how strongly, by comparing current prices to past prices.',
			inputs: [{ name: 'period', value: 20 }],
			fillToValue: 100,
			componentSeries: [
				{ id: 'momentum' }
			]
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		const style = this.params.style;
		// fill
		this.markers.line.renderFill(
			this.panel.rootContext,
			this._getDataMap(data.momentum),
			this.panel.size.padding.top + this.panel.size.height,
			this.xScale,
			this.yScale,
			style.background.color,
			this.params.fillToValue
		);

		// line
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
